export const ScatterDotSize = [1, 2, 3, 4, 5] as const;

export type ScatterDotSizeType = (typeof ScatterDotSize)[number];
